export default __webpack_public_path__ + "static/media/sectionio.b6ee0a41.svg";